import { Container } from '@presentation/components';
import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import * as Styled from './styled';
import type { FaqPageProps } from './types';

export * from './types';

export const FaqPage: FC<FaqPageProps> = (props) => {
  const { accordionComponent, resource } = props;

  const { translate: translateResource } = useTranslation({ keyPrefix: `faq.${resource}` });

  const title = translateResource('title');

  return (
    <>
      <Styled.HeaderWrapper>
        <Styled.StyledHeaderProfile title={title} />
      </Styled.HeaderWrapper>
      <Container>{accordionComponent}</Container>
    </>
  );
};
